import { gql } from '@apollo/client';

export const CREATE_POST_MUTATION = gql`
  mutation CreatePost($input: CreatePostInput!) {
    createPost(createPostInput: $input) {
      id
      authorId
      title
      body
      attachments
      dashboard
      expireDate
      createdAt
    }
  }
`;